import gql from 'graphql-tag';
import { buildConnectionQuery } from '../../../helpers.class';

export const nodeFragment = `
  id
  comment
  createdAt
  CreatedBy {
    id
    firstName
    lastName
  }
  CertificationId
`;

export const certificationAgencyCommentConnectionQuery = gql`${buildConnectionQuery('CertificationAgencyComment', 'certificationAgencyCommentConnection', nodeFragment)}`;

export const addCertificationAgencyCommentMutation = gql`mutation AddCertificationAgencyComment($input: AddCertificationAgencyCommentInput!) {
  addCertificationAgencyComment(input: $input) { ${nodeFragment} }
}`;
